/* global Ad */

// initialize PJAX
if ($.support.pjax) {
	$(document).pjax('.pjaxLink', '#serviceContent', {
		fragment: '#pjaxFragment',
		timeout: 5000,
		scrollTo: false
	});

	var promoBanners =  '';

	$(document).on('pjax:beforeSend', function(event) {
		$('#promoCode').data('show', 1);
		if (0 !== $('#serviceContent').find('.promoBanner').length) {
			promoBanners = $('#serviceContent').find('.promoBanner');
		}

		$(window).scrollTop(0).scrollLeft(0);
		$('#presentationOpacity').show();
		var $pjaxLink = $(event.relatedTarget),
			$pjaxHolder = $('#pjaxHolder');

		var direction = 'left';
		if ($pjaxLink.hasClass('pjaxBack')) {
			direction = 'right';
		}
		$pjaxHolder.hide('slide', {direction: direction}, 300, function() { $(this).addClass('magicHolder'); });

		if ($pjaxLink.hasClass('pjaxMenu')) {
			$('#privatepageMenu').css('display','none');
			setTimeout(function(){ $('#privatepageMenu').css('display',''); },500);
		}
		if ($pjaxLink.hasClass('pjaxHome')) {
			$('#privatepageTab').removeClass('active');
			$('#homepageTab').addClass('active');
		} else if ($pjaxHolder.hasClass('homepage')) {
			$('#homepageTab').removeClass('active');
			$('#privatepageTab').addClass('active');
		}

		Ad.Dom.abortRequests();
		if ($pjaxHolder.hasClass('presentation')) {
			// clear delayed shortlist/compare check at object/unit presentation
			if (window.delayFavoritesID) { clearTimeout(window.delayFavoritesID); }
			if (window.intervalCalculationID) { clearInterval(window.intervalCalculationID); }

			// clear nearby-refresh scroll event
			$window.off('scroll.nearby');
		}
		$('.ui-tooltip').hide();
	}).on('pjax:success', function() {
		if (promoBanners != '') {
			$('#serviceContent').prepend(promoBanners);
		}
		var isMapSearchPresent = $('#mapSearch').length;
        var $serviceWrapper = $('#serviceWrapper');

		if (isMapSearchPresent) {
			$serviceWrapper.addClass('searchResultsPage');
		} else {
			$serviceWrapper.removeClass('searchResultsPage');
		}

		$(window).scrollTop(0).scrollLeft(0);
		//Recent history
		if (Ad.recentHistory.historyChanged) {
			Ad.recentHistory.setViewport();
			if (!Ad.recentHistory.scrollSeted) {
				Ad.recentHistory.setScroll();
			}
			if (!Ad.recentHistory.clearSeted) {
				Ad.recentHistory.initClear();
			}
		}
		window.everPushedSomething = true;

		$('#serviceContent').find('.tooltip').tooltip({track: true, position: { my: "left+20 top+10", at: "right bottom" } });
		setGaqPage();
	});
}

// koristi se za pjax i paginaciju kod privatnog smjestaja
// fix za Chrome zato sta trigera popstate na page load
if (window.history.pushState) {
	window.everPushedSomething = false;
	var initialURL = window.location.href;

	$(window).on('popstate', function(e) {
		var onloadPop = !window.everPushedSomething && window.location.href == initialURL;
		window.everPushedSomething = true;
		if (onloadPop) return;

		window.location.reload();
	});
}
